'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.textarea.withConfig({
  componentId: 'sjthu8-0'
})(['box-sizing:border-box;margin:0 0 calc(', ' / 2);font-size:0.9em;line-height:inherit;font-family:inherit;overflow:auto;border:1px solid ', ';background-color:', ';border-radius:', ';padding:calc(', ' / 4) calc(', ' / 2);', ' ', ' ', ''], function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.theme.borderColor;
}, function (p) {
  return p.theme.inputBgColor;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.labelDisplay === 'inline' && '\n    width: ' + p.theme.inputWidth + ';\n  ';
}, function (p) {
  return p.labelDisplay === 'before' && '\n    width: ' + p.theme.inputWidth + ';\n    max-width: calc(100% - 10px);\n    min-width: ' + p.theme.inputWidth + ';\n    min-height: ' + p.theme.textAreaHeight + ';\n    resize:vertical;\n\n    @media (min-width: 768px) {\n      width: calc(' + p.theme.inlineLabelWidth + ' + ' + p.theme.inputWidth + ');\n    }\n  ';
}, function (p) {
  return !p.success && '\n    border-color: ' + p.theme.errorColor + ';\n    background-color: ' + p.theme.errorBgColor + ';\n\n    &::placeholder {\n      color: ' + p.theme.errorColor + ';\n    }\n  ';
});